export default {
  TITLE: "Tito - Le Téléphone Anti-Fake-News",
  LOGO: "./assets/images/logo-fr-fr.png",
  SUBTITLE: "Le Téléphone <br />Anti-Fake-News",
  TAB: "Tito et les Oiseaux",
  DOWNLOAD_TITLE: "À L'Attention des Enseignants",
  DOWNLOAD_TEXT:
    "Téléchargez le contenu ci-dessous pour  jouer au Téléphone Anti-Fake-News en classe.",
  DOWNLOAD_BUTTON: "Télécharger",
  PLAY_TEXT:
    "Découvre les aventures de Tito et ses amis, et comment sauver le monde de la désinformation.",
  PDF_LINK: "./tito-material-didatico-fr-fr.pdf",
  TITO_LINK: "http://titoandthebirds.com/",
  SITE_URL: "http://titoandthebirds.com/game/#/fr-fr",
  SITE_DESCRIPTION:
    "Enseignants, enfants et parents - Aprendez à lutter contre les infox avec Tito et les Oiseaux",
  COPYRIGHT: `Tito - Le Téléphone Anti-Fake-News by <a href="http://pushstart.com.br/" target="_blank" rel="noopener noreferrer"
  >PushStart</a>. © 2019 Bits Filmes. Tous droits réservés`,
  PIXEL_VISITORS_FRFR: "https://secure.adnxs.com/seg?add=17258326&t=2",
  PIXEL_CONVERSION_FRFR:
    "https://secure.adnxs.com/px?id=1087807&seg=17258326&t=2"
};



// WEBPACK FOOTER //
// ./src/utils/locales/fr-FR.js